import Button from '@zenbusiness/zui/Button';
import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: '24px 0px !important'
}));

export const ButtonStyled = styled(Button)(({ theme }) => ({
  height: '36px',
  padding: '0 16px!important',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    height: '40px',
    padding: '0 20px!important'
  }
}));
